import { createSlice } from "@reduxjs/toolkit";

const domainSlice = createSlice({
  name: "domains",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchDomainsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDomainsSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchDomainsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDomainsRequest,
  fetchDomainsSuccess,
  fetchDomainsFailure,
} = domainSlice.actions;

export default domainSlice.reducer;